export const YT_KEY = "AIzaSyBDsjqTXNG53Y2Hbjz6udkdPSi53GJ-0rI";
export const YT_API = `https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&regionCode=IN&maxResults=50&key=${YT_KEY}`;
export const OFFSET_LIVE_CHAT = 50;
